import React from 'react';
import { motion } from 'framer-motion';
import { Brain, AlertTriangle, Clock, HeartCrack } from 'lucide-react';
const problems = [{
  icon: <Clock className="w-8 h-8 text-red-500" data-id="element-191" />,
  title: 'El tiempo nunca alcanza',
  desc: 'Demasiados pacientes, demasiadas tareas y cero margen para frenar a buscar en un libro. Necesitás la respuesta correcta en segundos, no en capítulos.'
}, {
  icon: <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-192" />,
  title: 'El médico no contesta y el paciente empeora',
  desc: 'Sabés que algo no va bien, pero no llega nadie. Tenés que decidir qué hacés mientras tanto sin pasarte de tu rol ni quedarte corta.'
}, {
  icon: <Brain className="w-8 h-8 text-red-500" data-id="element-193" />,
  title: 'Miedo al error de medicación',
  desc: 'Goteos, diluciones, incompatibilidades, dosis pediátricas. Un solo cálculo mal y las consecuencias son enormes. La presión de no equivocarte es constante.'
}, {
  icon: <HeartCrack className="w-8 h-8 text-red-500" data-id="element-194" />,
  title: 'Registros que te salvan o te hunden',
  desc: 'Lo que firmás importa tanto como lo que hacés. Sin una estructura clara, cada turno es una exposición legal que suma estrés al cansancio.'
}];
export function Problems() {
  return <section className="py-20 bg-red-50 text-navy-900 px-4" data-id="element-195">
      <div className="max-w-5xl mx-auto" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-197">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-red-900" data-id="element-198">
            Sabemos exactamente por lo que estás pasando.
          </h2>
          <p className="text-lg text-red-800/70 max-w-3xl mx-auto" data-id="element-199">
            El problema no es tu conocimiento: es que la guardia no te da
            tiempo, el médico no está y cada decisión recae sobre vos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12" data-id="element-200">
          {problems.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white border border-red-200 p-6 rounded-2xl flex gap-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-201">
              <div className="shrink-0 bg-red-100 p-3 rounded-xl h-fit" data-id="element-202">
                {p.icon}
              </div>
              <div data-id="element-203">
                <h3 className="text-xl font-bold mb-2 text-red-900" data-id="element-204">
                  {p.title}
                </h3>
                <p className="text-red-800/80 text-sm leading-relaxed" data-id="element-205">
                  {p.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-206">
          <h3 className="text-2xl md:text-3xl font-bold text-navy-900 mb-2" data-id="element-207">
            Para eso diseñamos esto:
          </h3>
          <div className="w-24 h-1 bg-navy-800 mx-auto rounded-full mt-4" data-id="element-208"></div>
        </motion.div>
      </div>
    </section>;
}